//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loadMoreBtn from "@/common/components/load-more-btn/index.vue";
import gameList from "./item/index.vue";
import { commonApi } from "@/common/index";

export default {
  components: { loadMoreBtn, gameList },
  data() {
    return {
      platformList: [], // 电子的平台列表
      gameType: "-1", // 游戏类型
      platformCode: null, // 电子平台
      platformKey: null,
      platform: null, // 平台信息 类似电子一样列表显示的是游戏而不是平台
      loadmore: true,
      finish: Function,
      pages: { pageNo: 1, pageSize: 40 },
      list: [],
      total: null,
      maintain: "",
      maintainRemarks: "",
    };
  },
  activated() {
    this.gameType = this.$route.params.id || "1";
    this.pages.pageNo = 1;
    this.platformCode = this.$route.query.platformCode;
    this.platformKey = this.$route.query.platformKey;
    this.maintain = this.$route.query.maintain;
    this.maintainRemarks = this.$route.query.maintainRemarks;
    this._getLists(); // 获取游戏列表
  },
  deactivated() {
    this.list = [];
  },
  methods: {
    _refresh({ finish }) {
      // 刷新
      finish();
      const c = document.documentElement.scrollTop || document.body.scrollTop;
      if (c > 0) window.scrollTo(0, 0);
    },

    _loadmore({ finish }) {
      // 加载更多
      this.finish = finish;
      this.finish();
    },

    _getLists() {
      let params = {
        frontType: this.frontType, // 国际化类型
        platformCode: this.platformCode, // 平台游戏code
        gameType: this.gameType,
        ...this.pages,
      };
      if (this.isLogin) params.UUID = this.UUID;
      this.loadmore = true;
      this.$store.commit("updateLoadingStatus", { isLoading: true });
      commonApi.HOMEBEFORE.queryAllGameList(params)
        .then((data) => {
          console.log(data);
          const { list, total } = data;
          this.list =
            this.pages.pageNo === 1 ? [...list] : [...this.list, ...list];
          if (this.list.length === total) this.loadmore = false;
          this.finish();
          this.$store.commit("updateLoadingStatus", { isLoading: false });
        })
        .catch((err) => {
          this.loadmore = false;
          this.finish();
          this.$store.commit("updateLoadingStatus", { isLoading: false });
        });
    },

    loadMoreData({ finish }) {
      // 加载更多
      this.pages.pageNo += 1;
      this.finish = finish;
      this._getLists();
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/game/index.vue